import { Component } from '@angular/core';
import { CurrentUserService } from '../../services/current-user.service';
import { IUser } from '../../interfaces/user';
import { Observable } from 'rxjs';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';
@Component({
    selector: 'app-developer-menu',
    templateUrl: './developer-menu.component.html',
    styleUrls: ['./developer-menu.component.scss'],
    imports: [
    RouterLink,
    AsyncPipe
],
})
export class DeveloperMenuComponent {
  currentUser$: Observable<IUser>;
  showAccessClaimsButton: Observable<boolean>;
  showServiceGroupButton: Observable<boolean>;

  constructor(private readonly currentUserService: CurrentUserService) {
    this.currentUser$ = this.currentUserService.currentUser$;
    this.showAccessClaimsButton = this.currentUserService.hasClaim('AccessClaimGroups');
    this.showServiceGroupButton = this.currentUserService.hasClaim('ServiceGroups');
  }
}
